import "./StatusIcon.css"

export function StatusIcon(props) {
    return (
        <img className={props.className} src={props.icon} alt="Status" width={props.width} height={props.height} />
    );
}
